import React from 'react';
import Footer from '../components/Footer';
import Navbar from '../components/Navbar';

const Kundenerstinfo = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <div className="bg-black text-white">
        <Navbar />
      </div>
      <div className="bg-gray-50 flex-grow">
        <div className="container mx-auto px-6 py-12">
          <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-md p-8">
            <h1 className="text-3xl font-bold mb-8">Kundenerstinformation</h1>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">1. Name, Anschrift und Kontaktdaten</h2>
              <p>
                <strong>Name:</strong> BenefitWerk<br />
                <strong>Anschrift:</strong> Eyachstraße 37, 71065 Sindelfingen<br />
                <strong>Telefon:</strong> <a href="tel:+4917681237159" className="text-blue-600 underline">+49 176 81237159</a><br />
                <strong>E-Mail:</strong> <a href="mailto:info@benefitwerk.de" className="text-blue-600 underline">info@benefitwerk.de</a>
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">2. Tätigkeitsart</h2>
              <p>
                <strong>Versicherungsmakler:</strong> mit einer Erlaubnis nach § 34 d Abs. 1 der Gewerbeordnung
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">3. Zuständige Stelle für die Erlaubniserteilung</h2>
              <p>
                <strong>IHK Stuttgart</strong>
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">4. Registernummer und gemeinsame Registerstelle</h2>
              <p>
                <strong>Registernummer:</strong> D-OKLU-X2KJ7-59<br />
                <strong>Gemeinsame Registerstelle:</strong><br />
                Deutsche Industrie- und Handelskammer (DIHK)<br />
                Breite Str. 29, 10178 Berlin<br />
                <strong>Telefon:</strong> <a href="tel:01806005850" className="text-blue-600 underline">(0180) 60 05 85 0</a><br />
                <strong>Website:</strong> <a href="https://www.vermittlerregister.org" className="text-blue-600 underline" target="_blank" rel="noopener noreferrer">www.vermittlerregister.org</a>
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">5. Beratung</h2>
              <p>
                Die Tätigkeit beinhaltet auch eine Beratung.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">6. Art und Quelle der Vergütung</h2>
              <p>
                Die Vergütung der Tätigkeit erfolgt als:
              </p>
              <ul className="list-disc pl-6 space-y-2 mt-4">
                <li>Konkrete, individuell vereinbarte Zahlung durch den Kunden</li>
                <li>In der Versicherungsprämie enthaltene Provision, die vom jeweiligen Versicherungsunternehmen ausgezahlt wird</li>
                <li>Kombination aus beiden Varianten</li>
              </ul>
              <p className="mt-4">
                Dies ist abhängig von den Wünschen und Bedürfnissen des Kunden sowie von den vermittelten Versicherungsprodukten.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">7. Schlichtungsstelle</h2>
              <p>
                <strong>Schlichtungsstelle für gewerbliche Versicherungs-, Anlage- und Kreditvermittlung:</strong><br />
                Glockengießerwall 2, 20095 Hamburg
              </p>
            </section>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Kundenerstinfo;